import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SelectionView from '../views/SelectionView.vue'

const routes = [
  {
    path: '/',
    name: 'selecao',
    component: SelectionView
  },
  {
    path: '/:filial_slug/:ano',
    name: 'apresentacao',
    component: HomeView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
